export const showModalFormOrder = (data) => ({
  type: "SHOW_MODAL_FORM_ORDER",
  payload: data,
});

export const closeModalFormOrder = () => ({
  type: "CLOSE_MODAL_FORM_ORDER",
});
